import React from 'react';
import TextInput from '../../../components/UIComponent/TextInput';
import ModalBasic from '../../component/ModalBasic';
import ToggleSwitch from '../../../components/common/ToggleSwitch';
import Select from 'react-select';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';

function AdminPermissionPopup(props) {

    return (
        <ModalBasic
            id="admin-permission"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Admin details</span>

                <div className='item-grp grid grid-cols-2 gap-2.5 items-start mt-3 mb-3'>

                    <div className='input-grp'>
                        <label>Name</label>
                        <TextInput type='text'
                            id='name'
                            name='name'
                            value={props.permissionObject.name}
                            handleChange={(event) => props.handleChange(event, 'name')}
                            className={props.validState?.error?.name ? "error" : ""}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Username</label>
                        <TextInput type='text'
                            id='username'
                            name='username'
                            value={props.permissionObject.username}
                            handleChange={(event) => props.handleChange(event, 'username')}
                            className={props.validState?.error?.username ? "error" : ""}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Password</label>
                        <TextInput
                            type="password"
                            id="password"
                            name="password"
                            value={props.permissionObject.password}
                            handleChange={(event) => props.handleChange(event, 'password')}
                            className={props.validState?.error?.password ? "error" : ""}
                            isPassword={true}
                            showPassword={props.showPassword}
                            togglePassword={props.togglePassword}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Role</label>
                        {/* <Select
                            options={props.roles?.map(x => ({ label: x.roleName, value: x.roleId }))}
                            value={props.roles?.find(x => x.roleId === props.permissionObject.roleId)}
                            onChange={(e) => props.handleChangeFroDropdown(e, "roleId")}
                        /> */}
                        <MultiSelectDropdown
                            //className={props.validState?.error?.idEmployeeSalary !== undefined ? "error" : ""}
                            options={props.roles}
                            //value={props.employeeBasicDetails.idEmployeeSalary}
                            value={props.permissionObject.roleId ? props.roles?.find(x => x.value === props.permissionObject.roleId) : 0}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(
                                    event, "roleId"
                                )
                            }
                        />
                    </div>

                    <div className='input-grp !flex gap-[10px] items-center mt-5 '>
                        <label>Allow Login</label>
                        <ToggleSwitch
                            checked={props.permissionObject.allowLogin}
                            onChange={(e) => props.handleToggle(e, "allowLogin")}
                        />
                    </div>

                </div>
                {props.selectedId > 0 ?
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()}>Update</button>
                        <button className="delete-btn btns" onClick={() => props.delete()}>Delete</button>
                    </div>
                    :
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>

                }

            </div>

        </ModalBasic>
    )
}

export default AdminPermissionPopup;
